import React from "react";
import { Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SaveButtonProps {
  /** Unsaved changes: highlighted. Otherwise muted. */
  dirty: boolean;
  saving: boolean;
  /** The last save went through and nothing has changed since. */
  saved?: boolean;
  disabled: boolean;
  onClick: () => void;
}

/** The one Save the template pages show, with its dirty, saving and saved states. */
const SaveButton: React.FC<SaveButtonProps> = ({ dirty, saving, saved, disabled, onClick }) => (
  <Button
    type="button"
    size="sm"
    variant={dirty ? "default" : "outline"}
    onClick={onClick}
    disabled={disabled}
  >
    {saving ? (
      <Loader2 className="h-4 w-4 animate-spin" />
    ) : saved && !dirty ? (
      <Check className="h-4 w-4" />
    ) : null}
    {saved && !dirty && !saving ? "Saved" : "Save"}
  </Button>
);

export default SaveButton;
